import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {clothColors} from '../clothColors';
import {GeneralClairvoyantColorComponent} from '../g-clairvoyant-color.component';

@Component({
  selector: 'app-clairvoyant-color',
  templateUrl: './clairvoyant-color-two-player.component.html',
  styleUrls: ['./clairvoyant-color-two-player.component.css']
})
export class ClairvoyantColorTwoPlayerComponent extends GeneralClairvoyantColorComponent {

  isLeaved = false;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    super.initValues();
    this.isLeaved = false;
  }

  setSolution (capShirtShortColor: clothColors[]) {
    this.solution = capShirtShortColor;
    this.isOneCardTurned = true;
  }

  setLeaveRoom(isLeaved: boolean) {
    this.isLeaved = isLeaved;
  }
}
